import _ from 'lodash';

const state = {
  loading: false,
  loadingMessage: null,
  referer: null,
  filters: { status: 'request' },
  toaster: [],
};

const getters = {
  isLoading: state => state.loading,
  getLoadingMessage: state => state.loadingMessage,
  getReferer: state => state.referer,
  getFilters: state => state.filters,
  getToaster: state => state.toaster,
};

const mutations = {
  setLoading(state, { value, message = null }) {
    state.loading = value;
    state.loadingMessage = message;
  },
  setReferer(state, route) {
    state.referer = route;
  },
  setFilters(state, filters) {
    state.filters = filters;
  },
  handleToaster(state, error) {
    let exisitingToast = undefined;
    _.forEach(error, e => {
      exisitingToast = _.find(state.toaster, toast => toast.error === e.error);
      if (!exisitingToast) {
        state.toaster.push(e);
      }
    });
  },
  clearToaster(state, time) {
    state.toaster = state.toaster.filter(e => e.time !== time);
  },
  clearToasters(state) {
    state.toaster = [];
  },
};

const actions = {
  setLoading({ commit }, { value, message = null }) {
    commit('setLoading', { value, message });
  },
  setReferer({ commit }, route) {
    commit('setReferer', route);
  },
  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },
  setToaster({ commit }, error) {
    commit('handleToaster', error);
  },
  clearToaster({ commit }, time) {
    commit('clearToaster', time);
  },
  clearToasters({ commit }) {
    commit('clearToasters');
  },
};

export default { namespaced: true, actions, state, getters, mutations };
